"use strict";
// Reusable Stevie Images for tiles
Object.defineProperty(exports, "__esModule", { value: true });
exports.spritesCrew = void 0;
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
exports.spritesCrew = imageRecycler_sidecar_1.imageRecycler.create('crew', function () { return voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrew; });
